import React, {ChangeEvent} from 'react';
import {IconButton, useTheme} from '@mui/material';
import {useSearchParams} from 'react-router-dom';

import Icon from 'presentation/icons';
import {QueryParamsEnum} from 'presentation/constants';
import {StyledInputBase, StyledPaper} from './styles';
import {SearchBarProps} from './types';

export function SearchBar({placeholder, readOnly}: SearchBarProps) {
	const theme = useTheme();
	const [searchParams, setSearchParams] = useSearchParams();

	const query = searchParams.get(QueryParamsEnum.SEARCH_QUERY);

	function handleChange(e: ChangeEvent<HTMLInputElement>) {
		setSearchParams(
			prev => {
				prev.set(QueryParamsEnum.SEARCH_QUERY, e.target.value);
				prev.delete(QueryParamsEnum.SEARCH_BY_LETTER);

				return prev;
			},
			{
				replace: true,
			},
		);
	}

	function clearSearch() {
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.SEARCH_QUERY);
				prev.delete(QueryParamsEnum.SEARCH_BY_LETTER);

				return prev;
			},
			{
				replace: true,
			},
		);
	}

	return (
		<StyledPaper component="form" elevation={0}>
			<Icon name="search-lens" color={theme.palette.action.active} />
			<StyledInputBase
				readOnly={readOnly}
				value={query || ''}
				onChange={handleChange}
				placeholder={placeholder}
				inputProps={{
					'aria-label': placeholder,
					style: {cursor: readOnly ? 'pointer' : 'initial'},
				}}
			/>
			{query ? (
				<IconButton
					type="button"
					aria-label="clear search"
					size="small"
					onClick={clearSearch}>
					<Icon name="close-filled" />
				</IconButton>
			) : null}
		</StyledPaper>
	);
}
